import { Skeleton, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';

export interface TotalResultsCountProps {
  /** Total number of results. When undefined, nothing is rendered. */
  count: number | undefined;
  /** When true, shows a skeleton placeholder instead of the count. */
  isLoading?: boolean;
}

/**
 * Displays total results count with "X resultados" message, or a loading skeleton.
 * Used in list-view and report actions bars.
 * Shows skeleton on first load (no count yet) and when refreshing (count present).
 */
export function TotalResultsCount({ count, isLoading = false }: TotalResultsCountProps) {
  if (isLoading) {
    return <Skeleton variant="text" width={80} height={24} />;
  }

  if (count === undefined) {
    return null;
  }

  return (
    <Typography variant="body2" color="text.secondary">
      <FormattedMessage
        id="common.listView.totalResults"
        defaultMessage="{count, number} resultados"
        values={{ count }}
      />
    </Typography>
  );
}
